import base from './config.json'

export let CONFIG: typeof base = base

export async function initialise(): Promise<void> {
  const filename = getConfigFileName()
  CONFIG = filename ? ((await fetchConfig(filename)) ?? base) : base
}

async function fetchConfig(name: string): Promise<typeof base | undefined> {
  try {
    // The version is a path segment only when a build stamped one. Unversioned otherwise --
    // `0.0.0/` would be a directory that never exists, so dev and any unstamped build would
    // 404 and fall back to the bundled config without saying why.
    const version = globalThis.__VERSION__
    const url = version ? `/static/config/${version}/${name}` : `/static/config/${name}`

    const response = await fetch(url, {
      headers: { 'Content-Type': 'application/json' },
    })

    if (!response.ok) {
      return undefined
    }

    return await response.json()
  } catch {
    return undefined
  }
}

function getConfigFileName(): string | undefined {
  if (import.meta.env.VITE_CONFIG_ENV) {
    return `${import.meta.env.VITE_CONFIG_ENV}.json`
  }

  // The e2e specs stub every request, relative to wherever the app is served.
  if ('Cypress' in globalThis) {
    return undefined
  }

  if (globalThis.__CONFIG_TARGET__) {
    return `${globalThis.__CONFIG_TARGET__}.json`
  }

  return undefined
}
